import {assert} from 'Asserts';
import removeNulls from 'util/removeNulls';
import {WorklistType} from 'worklists/WorklistConstants';

import {SampleFilter, SampleFilterType, SimpleSampleFilters} from '../SampleFilter';

/**
 * Utilities for converting between sample types (expressed as SampleFilter) and worklist types
 */

/**
 * Converts `SampleFilter`s to `WorklistType`s. Ignores `SampleFilter`s (like boolean filters) that are not
 * compatible with worklists, so the returned array may be smaller than the input.
 */
export function sampleFiltersToWorklistTypes(sampleFilters: Array<SampleFilter>): Array<WorklistType> {
  return removeNulls(sampleFilters.map((sampleFilter) => sampleFilterToWorklistType(sampleFilter)));
}

/**
 * Converts a sample filter to a worklist type. Returns null if sample filter is incompatible with worklists.
 */
export function sampleFilterToWorklistType(sampleFilter: SampleFilter): WorklistType | null {
  const sampleFilterTypeToWorklistType: Partial<Record<SampleFilterType, WorklistType>> = {
    [SampleFilterType.BIOENTITY]: WorklistType.BIOENTITY,
    [SampleFilterType.CONTAINER]: WorklistType.CONTAINER,
    [SampleFilterType.PLATE]: WorklistType.PLATE,
  };
  return sampleFilterTypeToWorklistType[sampleFilter.type] ?? null;
}

/**
 * Converts a worklist type to a sample filter. Throws assertion error for incompatible worklist types.
 */
export function worklistTypeToSampleFilter(worklistType: WorklistType): SampleFilter {
  const worklistTypeToSampleFilter: Partial<Record<WorklistType, SampleFilter>> = {
    [WorklistType.BIOENTITY]: SimpleSampleFilters.BIOENTITY,
    [WorklistType.CONTAINER]: SimpleSampleFilters.CONTAINER,
    [WorklistType.PLATE]: SimpleSampleFilters.PLATE,
  };

  const sampleFilter = worklistTypeToSampleFilter[worklistType];
  assert(sampleFilter !== undefined, `Incompatible worklistType: ${worklistType}`);
  return sampleFilter;
}
